import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { readJson, writeJson } from '@/lib/storage'
import en from './locales/en'
import pl from './locales/pl'

export type Lang = 'pl' | 'en'

const LANG_KEY = 'lang.v1'

/** Stored choice wins, then the browser language, then Polish (the fair is in Poland). */
function detectLang(): Lang {
  const stored = readJson<string>(LANG_KEY, '')
  if (stored === 'pl' || stored === 'en') return stored
  const browser = typeof navigator === 'undefined' ? '' : navigator.language
  return browser.toLowerCase().startsWith('en') ? 'en' : 'pl'
}

function applyDocumentLang(lang: Lang): void {
  if (typeof document !== 'undefined') document.documentElement.lang = lang
}

const initial = detectLang()

/** Resolves once resources are registered; `src/main.tsx` awaits it. */
export const i18nReady: Promise<void> = i18n
  .use(initReactI18next)
  .init({
    lng: initial,
    fallbackLng: 'pl',
    supportedLngs: ['pl', 'en'],
    // Both locales are bundled — the game has to work with no network at the stand.
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
  })
  .then(() => applyDocumentLang(initial))

export function setLang(l: Lang): void {
  writeJson(LANG_KEY, l)
  void i18n.changeLanguage(l)
  applyDocumentLang(l)
}

export function getLang(): Lang {
  const active = i18n.resolvedLanguage ?? i18n.language ?? ''
  return active.toLowerCase().startsWith('en') ? 'en' : 'pl'
}

export default i18n
